import * as types from '@/store/mutation-types'

export default {
  [types.SET_SELECTED_LOCATION](state, location) {
    state.selectedLocation = location
  },
  [types.SET_CREATE_LOCATION_DIALOG](state, payload) {
    state.createLocationDialog = payload
  },
  [types.SET_LOCATION_EDIT_DIALOG](state, payload) {
    state.locationEditDialog = payload
  },
  [types.SET_LOCATION_IMAGES](state, images) {
    state.images = images
  },
  [types.SET_ZONES_RELOAD](state, value) {
    state.enableZonesReload = value
  }
}
